import { MAIN_SITE_GENERAL_PAGE_ROUTE_NAME } from '@/constants/routes'
import md5 from 'md5'

const IS_DEV = process.env.NODE_ENV === 'development'
const MAIN_SITE_URL = IS_DEV
  ? ''
  : (process.env.VUE_APP_MAIN_SITE_URL || MAIN_SITE_GENERAL_PAGE_ROUTE_NAME).replace(/\/$/, '')

export function getEntityTypeFromUrl(url) {
  if (!url) return null
  try {
    const { pathname } = new URL(url)
    const segments = pathname.split('/').filter(Boolean)
    return segments[0] || null
  } catch {
    return null
  }
}

export function getIdSlug({ id, slug }) {
  if (!id || !slug) return null
  return `${id}-${slug}`
}

export function extractAdvertSlug(entityId) {
  if (!entityId) return ''
  const segment = String(entityId)
    .replace(/^\//, '')
    .trim()
  const match = segment.match(/^(\d+)-(.+)$/)
  return match ? match[2] : segment
}

export function getMainSiteObjectUrl({ entityType, id, slug, fallbackUrl = null }) {
  const idSlug = getIdSlug({ id, slug })
  if (!entityType || !idSlug) return fallbackUrl
  const base = (process.env.VUE_APP_MAIN_SITE_URL || MAIN_SITE_GENERAL_PAGE_ROUTE_NAME).replace(/\/$/, '')
  return `${base}/${entityType}/${idSlug}`
}

export function getPresentationPreviewUrl({ entityType, entityId, mobile = false }) {
  const base = (process.env.VUE_APP_MAIN_SITE_URL || MAIN_SITE_GENERAL_PAGE_ROUTE_NAME).replace(/\/$/, '')
  const advertSlug = extractAdvertSlug(entityId)
  const hash = md5(`${advertSlug}${process.env.VUE_APP_SECRET_HASH_KEY ?? ''}`)
  const params = new URLSearchParams({
    preview: '1',
    hash
  })
  if (mobile) params.set('mobile', '1')
  return `${base}/${entityType}/${entityId}/presentation?${params.toString()}`
}

export async function downloadPresentation({ entityType, entityId, mobile = false }) {
  const response = await fetch(`${MAIN_SITE_URL}/api/presentation/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ entityType, entityId: String(entityId), mobile }),
    credentials: 'include'
  })

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`)
  }

  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `presentation-${entityId}${mobile ? '-mobile' : ''}.pdf`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
